/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetActorResponseJson } from './get-actor-response-json';
import { GetActorResult } from '../results/get-actor-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ActorDto } from '../models/actor-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetActorResponse extends ResponseWithErrorGeneric<GetActorResponseJson, GetActorResult> implements IResponseWithErrorGeneric<GetActorResult> {
  public actor: ActorDto;

  //<custom-body>
  constructor(response: HttpResponse<GetActorResponse>) {
    super(response, GetActorResult.InvalidActor);
    if (this.result === GetActorResult.Success) {
      this.actor = new ActorDto(this.body.actor);
    }
  }
  //</custom-body>
}
